export default __webpack_public_path__ + "static/media/SiteDesign.2fe7a682.jpg";